import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress, _DeliveryType, _FreightType, _GoodsState, _GoodsSupport, _GoodsType, _UBLPaymentMeans } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { GuideFreightTypeConstants } from "./GuideFreightTypeConstants/GuideFreightTypeConstants";


export const GoodsType = () => {

    const goodstype = useDataBean(_GoodsType);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [regexStr, setregexStr] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        goodstype.instance.getGoodsTypeCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        goodstype.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        goodstype.instance.deleteGoodsType(goodstype.bean.IDGoodsType).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        goodstype.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDGoodsType', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Tipo', property: 'Type', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Tipos de Bienes de Carga">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={goodstype.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={goodstype.bean.Name} onChange={goodstype.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <GuideFreightTypeConstants idSelector={goodstype.bean.Type} onChange={(e: any) => { goodstype.setBean({ ...goodstype.bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={goodstype.bean.Description} onChange={goodstype.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {goodstype.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}